import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';

class ToggleInput extends Component {
    static propTypes = {
        input: PropTypes.shape({
            value: PropTypes.bool,
            name: PropTypes.string,
            onChange: PropTypes.func
        }),
        meta: PropTypes.shape({
            valid: PropTypes.bool,
            error: PropTypes.string,
            touched: PropTypes.bool
        }),
        disabled: PropTypes.bool,
        id: PropTypes.string,
        inputClassName: PropTypes.string
    };

    render() {
        const {
            input: { value, name, onChange },
            disabled,
            inputClassName,
            id = null
        } = this.props;
        const {
            meta: { valid, error, touched }
        } = this.props;

        return (
            <div className={`${inputClassName} toggle-input-container`}>
                <Toggle
                    name={name}
                    disabled={disabled}
                    checked={!!value}
                    onChange={(event) => onChange(event.target.checked)}
                    id={id}
                />
                {!valid && touched ? error : ''}
            </div>
        );
    }
}

export default ToggleInput;
